/**
 * @name api/phone_number_authorization.js
 * @module app
 *
 * @description
 * Mocking client-server processing
 *
 * @project spotgig4app
 * @author Hyuga on 2019/06/03
 * Copyright © 2017年 Axis-motion. All rights reserved.
 */

import API from '../api'
// const API_URI = '/api/v1/phone_number_authorizations'
const API_URI = '/v1/phone_number_authorizations'

export default {
  regist(params) {
    return API.request('post', API_URI + '/regist', params)
  },
  certification(params) {
    return API.request('post', API_URI + '/certification', params)
  },
}
